var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTenantDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 27H30V30H0V27ZM3 15H6V25.5H3V15ZM10.5 15H13.5V25.5H10.5V15ZM16.5 15H19.5V25.5H16.5V15ZM24 15H27V25.5H24V15ZM0 7.5L15 0L30 7.5V13.5H0V7.5ZM15 9C15.3978 9 15.7794 8.84196 16.0607 8.56066C16.342 8.27936 16.5 7.89782 16.5 7.5C16.5 7.10218 16.342 6.72064 16.0607 6.43934C15.7794 6.15804 15.3978 6 15 6C14.6022 6 14.2206 6.15804 13.9393 6.43934C13.658 6.72064 13.5 7.10218 13.5 7.5C13.5 7.89782 13.658 8.27936 13.9393 8.56066C14.2206 8.84196 14.6022 9 15 9V9Z",
    fill: "#082026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenantDark);
export default __webpack_public_path__ + "static/media/tenant-dark.b50ab4f4bb36379433e8bb1b3cc54da2.svg";
export { ForwardRef as ReactComponent };